import { render, staticRenderFns } from "./Bedside.vue?vue&type=template&id=0f6f868f&scoped=true"
import script from "./Bedside.vue?vue&type=script&lang=js"
export * from "./Bedside.vue?vue&type=script&lang=js"
import style0 from "./Bedside.vue?vue&type=style&index=0&id=0f6f868f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f868f",
  null
  
)

export default component.exports